// Which Iconify names Icon.vue draws as a Carbon icon. Empty by default, so a bundle that never registers (widget,
// portal, survey, sdk) keeps the Iconify icons and never ships carbonMap.js or @carbon/icons-vue. The dashboard and
// the v3 login register CARBON_ICONS before they mount; Histoire does the same in its setup file.
const carbonIcons = new Map();

export const registerCarbonIcons = map => {
  Object.entries(map).forEach(([name, component]) =>
    carbonIcons.set(name, component)
  );
};

export const carbonIconFor = name => carbonIcons.get(name);

// Whether this bundle registered any Carbon icon (so a miss is worth reporting).
export const hasCarbonIcons = () => carbonIcons.size > 0;
